"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
const react_1 = require("react");
const AuthProvider_1 = require("../providers/AuthProvider");
const MainProvider_1 = require("src/providers/MainProvider");
const AsideMenu_1 = tslib_1.__importDefault(require("src/layouts/AsideMenu"));
const PrivateFooterLayout_1 = tslib_1.__importDefault(require("src/layouts/PrivateFooterLayout"));
const PlaceholderCardLoading_1 = tslib_1.__importDefault(require("src/components/loadings/PlaceholderCardLoading"));
const PrivateHeaderLayout_1 = tslib_1.__importDefault(require("src/layouts/PrivateHeaderLayout"));
const IndexComponent_1 = tslib_1.__importDefault(require("src/modules/version/views/IndexComponent"));
const PrivateLayout = () => {
    const auth = (0, AuthProvider_1.useAuth)();
    const globalVariables = (0, MainProvider_1.useMain)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    (0, react_1.useEffect)(() => {
        const checkAuthUser = async () => {
            const token = localStorage.getItem('token');
            if (token && auth.getAuthUser) {
                const fetchedUser = await auth.getAuthUser();
                if (!fetchedUser)
                    navigate('/login');
            }
            else {
                navigate('/login');
            }
        };
        if (!auth.state.data.user)
            checkAuthUser().then();
    }, []);
    return ((0, jsx_runtime_1.jsxs)("div", { className: 'd-flex flex-row flex-column-fluid page', children: [(0, jsx_runtime_1.jsx)(AsideMenu_1.default, { toggleMobileCollapse: globalVariables.setMobileCollapsed, mobileCollapsed: globalVariables.mobileCollapsed, loading: auth.state.isFetchingUser }), (0, jsx_runtime_1.jsxs)("div", { className: 'd-flex flex-column flex-row-fluid wrapper', children: [(0, jsx_runtime_1.jsxs)("div", { className: 'header header-fixed d-flex flex-column', children: [(0, jsx_runtime_1.jsx)(IndexComponent_1.default, {}), (0, jsx_runtime_1.jsx)(PrivateHeaderLayout_1.default, { signout: auth.signout, authState: auth.state, fetchUser: auth.getAuthUser, toggleMobileCollapse: globalVariables.setMobileCollapsed })] }), (0, jsx_runtime_1.jsx)("div", { className: 'content d-flex flex-column flex-column-fluid', children: auth.state.isFetchingUser
                            ? (0, jsx_runtime_1.jsx)(PlaceholderCardLoading_1.default, {})
                            : (0, jsx_runtime_1.jsx)(react_router_dom_1.Outlet, {}) }), (0, jsx_runtime_1.jsx)(PrivateFooterLayout_1.default, {})] })] }));
};
exports.default = PrivateLayout;
